module.exports = __webpack_public_path__ + "static/media/logo.2fb2f28c.svg";